import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import API from "../api";
import "./EmailFinalScreen.css";
import profile from "../assets/images/profile.png";
import logo from "../assets/images/logo_cyber_112.png";

const EmailFinals = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const module_id = location?.state?.module_id || 1;
  
  // ✔️ PRIMAMO TAČAN SCORE OD MODULA
  const moduleScore = location?.state?.moduleScore || 0;

  const rawUserId = localStorage.getItem("userId");
  const userId =
    rawUserId && rawUserId !== "null" ? parseInt(rawUserId, 10) : null;

  const [scoreVisible, setScoreVisible] = useState(false);
   const [isUpdating, setIsUpdating] = useState(false); //novo

  const [userData, setUserData] = useState({
    first_name: "",
    last_name: "",
    username: "",
    totalScore: 0, // total XP iz baze
    rank: 4,
    completion: "10%",
    days: 0,
  });

  const calculateDays = () => {
    const startDate = new Date("2025-12-12");
    const currentDate = new Date();
    const diff = startDate - currentDate;
    return Math.max(0, Math.floor(diff / (1000 * 3600 * 24)));
  };

  // FETCH USER DATA (TOTAL SCORE ZA SIDEBAR)
  useEffect(() => {
    const loadData = async () => {
      try {
        const [userResp, totalScoreResp] = await Promise.all([
          API.get("/user/userD"),
          API.get(`/module/score/${userId}`)
        ]);

        const userInfo = userResp.data?.data?.[0] || {};
        const totalScore = totalScoreResp.data[0]?.score || 0;

        setUserData({
          first_name: userInfo.first_name || "",
          last_name: userInfo.last_name || "",
          username: userInfo.username || "",
          totalScore, // ✔️ ovo je samo za sidebar
          rank: userInfo.rank || 4,
          completion: userInfo.completion || "10%",
          days: calculateDays(),
        });

      } catch (err) {
        console.error("Greška pri učitavanju korisničkih podataka:", err);
      }
    };

    if (userId) loadData();
  }, [userId]);

  useEffect(() => {
    setTimeout(() => setScoreVisible(true), 200);
  }, []);


  // FUNKCIJA ZA UPDATE TOTAL SCOREA - Kao na telefonu
  const updateTotalScore = async () => {
    if (!userId || isUpdating) return;
    
    setIsUpdating(true);
    try {
      // 1. Dohvati trenutni ukupni score korisnika
      const currentScoreResponse = await API.get(`/module/getScore/${userId}`);
      const currentScoreData = currentScoreResponse.data?.[0];
      
      if (currentScoreData) {
        // 2. Ako postoji score, ažuriraj ga (trenutni + moduleScore)
        await API.post("/module/updateScore", {
          score: currentScoreData.score + moduleScore,
          id: userId
        });
      } else {
        // 3. Ako ne postoji score, kreiraj novi
        await API.post("/module/setScore", {
          score: moduleScore,
          id: userId
        });
      }
      // 4. Ažuriraj sidebar sa novim score-om
      const updatedResponse = await API.get(`/module/score/${userId}`);
      const updatedScore = updatedResponse.data[0]?.score || 0;
      
      setUserData(prev => ({
        ...prev,
        totalScore: updatedScore
      }));
      
      return true;
    } catch (err) {
      console.error("Greška pri ažuriranju ukupnog score-a:", err);
      return false;
    } finally {
      setIsUpdating(false);
    }
  };

  // ✔️ SNIMAMO MODULE SCORE U BAZU (Samo XP za ovaj modul!)
  const handleNextModule = async () => {
    try {

      // Prvo ažuriraj total score
      await updateTotalScore();

      await API.post("/module/setResult", {
        module: module_id,
        score:moduleScore,   // ✔️ TAČNO: samo module XP
        id: userId
      });

      navigate("/dash");
    } catch (err) {
      console.error("Greška pri spremanju rezultata:", err);
    }
  };

  const handleBonus = async () => {
    try {

       // Prvo ažuriraj total score
      await updateTotalScore();
      
      await API.post("/module/setResult", {
        module: module_id,
        score: moduleScore,
        id: userId
      });
      navigate("/bonus-text-screen", { state: { module_id } });
    } catch (err) {
      console.error("Greška pri spremanju rezultata:", err);
    }
  };

  return (
    <div className="dashboard-container2">
      <div className="main-content-web">
        <div className="email-prevare-content">
          <img src={logo} alt="Cyber Awareness Logo" className="email-prevare-logo" />

          <h2 className="module-title">CYBER AWARENESS TRAINING CENTRE</h2>
          <h2 className="module-title">TRAINING MODUL 1 - EMAIL PREVARE</h2>

          <p className="module-description">USPJEŠNO STE SAVLADALI MODUL 1</p>

          {/* ✔️ PRIKAZUJEMO SAMO SCORE ZA OVAJ MODUL */}
          <div className={`score-container ${scoreVisible ? "show-score" : ""}`}>
            <span className="score-text">{moduleScore} XP</span>
          </div>

          <button className="start-lesson-btn" onClick={handleNextModule}>
            NEXT MODULE
          </button>

          <button className="start-lesson-btn" onClick={handleBonus}>
            BONUS XP
          </button>
        </div>
      </div>

      {/* SIDEBAR */}
      <div className="sidebar">
        <div className="profile">
          <img src={profile} alt="Profile" className="profile-img" />
          <h4>{userData.first_name} {userData.last_name}</h4>
          <p>@{userData.username}</p>
        </div>

        <div className="profile-info">
          <div className="profile-info-header">
            <h4>Profile Info</h4>
          </div>

          <div className="info-item">
            <span>🏆 Rank:</span> {userData.rank}
          </div>

          <div className="info-item">
            <span>💡 Total score:</span> {userData.totalScore}
          </div>

          <div className="info-item">
            <span>❌ Completion:</span> {userData.completion}
          </div>

          <div className="info-item">
            <span>📅 Days:</span> {userData.days}
          </div>
        </div>

        <div className="logout-container">
          <button onClick={() => navigate("/login")} className="logout-btn">
            Log out
          </button>
        </div>
      </div>
    </div>
  );
};

export default EmailFinals;